import React from 'react';
import { Link } from 'gatsby-plugin-intl';
import { getCurrentLangKey } from '../../utils/getCurrentLangKey';

import styled from 'styled-components';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';


export const PaginationLinks = (props) => {
  const langKey = getCurrentLangKey();

  const prevLink = (props.currentPage > 2) ? `/${props.link}/${props.currentPage - 1}` : `/${props.link}`;
  const nextLink = (props.currentPage !== props.totalPages) ? `/${props.link}/${props.currentPage + 1}` : `/${props.link}`;

  return (
    <PaginationLinksWrapper start={props.start} currentPage={props.currentPage} totalPages={props.totalPages}>
      <Link to={prevLink} language={langKey} className="prev" title="Previous"><FaChevronLeft /><span>Previous</span></Link>
      <Link to={nextLink} language={langKey} className="next" title="Next"><span>Next</span> <FaChevronRight /></Link>
    </PaginationLinksWrapper>
  )
}

const PaginationLinksWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 15px 0;
  justify-content: space-between;
  margin: 25px 0;
  border-top: 1px dotted #ccc;
  .prev{
    display: flex;
    visibility: ${props => props.start ? 'visible' : 'hidden'};
    span{
      padding-left: 5px;
    }
  }
  .next{
    display: flex;
    visibility: ${props => (props.totalPages === props.currentPage) ? 'hidden' : 'visible'};
    span{
      padding-right: 5px;
    }
  }
` 
